/** Compare the complete query scope, ignoring only page and pageSize in filter objects. */
export function samePageScope(previousKey: readonly unknown[] | undefined, currentKey: readonly unknown[]): boolean {
  if (!previousKey) return false
  const scope = (key: readonly unknown[]) => JSON.stringify(key.map(part => {
    if (!part || typeof part !== 'object' || Array.isArray(part)) return part
    return Object.fromEntries(Object.entries(part).filter(([name]) => name !== 'page' && name !== 'pageSize').sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0))
  }))
  return scope(previousKey) === scope(currentKey)
}
